import {
  actionTypes,
  adminOfficePaginatedBrRequestFailure,
  adminOfficePaginatedBrRequestSuccess,
  adminOfficePaginatedEntitlementRequestFailure,
  adminOfficePaginatedEntitlementRequestSuccess,
  baoEntitlementRequestFailure,
  baoEntitlementRequestSuccess,
  blockAccountActionFailure,
  blockAccountActionSuccess,
  changePasswordActionFailure,
  changePasswordActionSuccess,
  createRequestFailure,
  createRequestSuccess,
  entitlementRequestFailure,
  entitlementRequestSuccess,
  getUserListActionFailure,
  getUserListActionSuccess,
  officeEntitlementRequestFailure,
  officeEntitlementRequestSuccess,
  officeRequestFailure,
  officeRequestSuccess,
  passwordPolicyUsersMgmtFailure,
  passwordPolicyUsersMgmtSuccess,
  resetPasswordFailure,
  resetPasswordSuccess,
  sodConflictsActionFailure,
  sodConflictsActionSuccess,
  unlockPasswordActionFailure,
  unlockPasswordActionSuccess,
  userManagersRequestFailure,
  userManagersRequestSuccess,
  userOusRequestFailure,
  userOusRequestSuccess,
  updateMobileActionFailure,
  updateMobileActionSuccess,
  userRequestFailure,
  userRequestSuccess,
  usersAccountRequestFailure,
  usersAccountRequestSuccess,
  userManagementGetRolesActionSuccess,
  userManagementGetRolesActionFailure,
  userManagementGetButtonsByRoleActionSuccess,
  userManagementGetButtonsByRoleActionFailure,
  userManagementUpdateConfigButtonsActionSuccess,
  userManagementUpdateConfigButtonsActionFailure,
  userManagementGetConfigActionSuccess,
  userManagementGetConfigActionFailure,
} from "./actions";

import {
  adminUpdateMobileService,
  fetchBAOEntitlementRequest,
  fetchBlockAccount,
  fetchCreateRequest,
  fetchEntitlementRequest,
  fetchOfficeEntitlementRequest,
  fetchOfficeRequest,
  fetchPasswordPolicyUsersMgmt,
  fetchResetPassword,
  fetchRestorePassword,
  fetchUserList,
  fetchUserRequest,
  fetchUsersAccountRequest,
  fetchUsersManagersService,
  fetchUsersOusServices,
  getPaginatedBusinessRoleRequestService,
  getPaginatedEntitlementRequestService,
  postChangePassword,
  userManagementGetButtonsByRolesService,
  userManagementGetConfigsService,
  userManagementGetRolesService,
  userManagementUpdateConfigsService,
} from "./services";

import { ofType } from "redux-observable";
import { of } from "rxjs";
import { catchError, map, mergeMap } from "rxjs/operators";
import { fetchSODConflicts } from "../../../../common/SODUtils/SODservices";
import { IGetUserListBody } from "../UsersManagementStepOne/module/constants";

const fetchUserManagersRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_ADMIN_USER_MANAGERS),
    mergeMap((action: any) =>
      fetchUsersManagersService(action.payload).pipe(
        map((response: any) => userManagersRequestSuccess(response)),
        catchError((error: any) => of(userManagersRequestFailure(error)))
      )
    )
  );

const fetchUserOusRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_ADMIN_USER_OUS),
    mergeMap((action: any) =>
      fetchUsersOusServices(action.payload).pipe(
        map((response: any) => userOusRequestSuccess(response)),
        catchError((error: any) => of(userOusRequestFailure(error)))
      )
    )
  );

const fetchGetPolicyAccountUsersMgmtEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_POLICY_ACCOUNT_USERS_MGMT),
    mergeMap((action: any) =>
      fetchPasswordPolicyUsersMgmt(action.payload).pipe(
        map((response: any) => passwordPolicyUsersMgmtSuccess(response)),
        catchError((error: any) => of(passwordPolicyUsersMgmtFailure(error)))
      )
    )
  );

const fetchAdminUsersAccountRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.ADMIN_USERS_MANAGEMENT_ACCOUNT_REQUEST),
    mergeMap((action: any) =>
      fetchUsersAccountRequest(action.id).pipe(
        map((response: any) => usersAccountRequestSuccess(response)),
        catchError((error: any) => of(usersAccountRequestFailure(error)))
      )
    )
  );

const fetchResetPasswordEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.ADMIN_RESET_PASSWORD),
    mergeMap((action: any) =>
      fetchResetPassword(action.payload).pipe(
        map((response: any) => resetPasswordSuccess(response)),
        catchError((error: any) => of(resetPasswordFailure(error)))
      )
    )
  );

const fetchBlockAccountEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.ADMIN_BLOCK_ACCOUNT),
    mergeMap((action: any) =>
      fetchBlockAccount(action.payload).pipe(
        map((response: any) => blockAccountActionSuccess(response)),
        catchError((error: any) => of(blockAccountActionFailure(error)))
      )
    )
  );

const fetchUserListEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.ADMIN_GET_USER_LIST),
    mergeMap((action: { payload: IGetUserListBody }) =>
      fetchUserList(action.payload).pipe(
        map((response: any) => getUserListActionSuccess(response)),
        catchError((error: any) => of(getUserListActionFailure(error)))
      )
    )
  );

const fetchEntitlementRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.ADMIN_ENTITLEMENT_REQUEST_USERS_MANAGEMENT),
    mergeMap((action: any) =>
      fetchEntitlementRequest(action.selectedUsers).pipe(
        map((response: any) => entitlementRequestSuccess(response)),
        catchError((error: any) => of(entitlementRequestFailure(error)))
      )
    )
  );

const fetchUnlockPassword = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.ADMIN_UNLOCK_PASSWORD),
    mergeMap((action: any) =>
      fetchRestorePassword(action.payload).pipe(
        map((response: any) => unlockPasswordActionSuccess(response)),
        catchError((error: any) => of(unlockPasswordActionFailure(error)))
      )
    )
  );

const fetchOfficeRequestsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.ADMIN_OFFICE_REQUEST),
    mergeMap(() =>
      fetchOfficeRequest().pipe(
        map((response: any) => officeRequestSuccess(response)),
        catchError((error: any) => of(officeRequestFailure(error)))
      )
    )
  );

const fetchUserRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.ADMIN_USER_REQUEST),
    mergeMap((action: any) =>
      fetchUserRequest(action.id).pipe(
        map((response: any) => userRequestSuccess(response)),
        catchError((error: any) => of(userRequestFailure(error)))
      )
    )
  );

const fetchOfficeEntitlementRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.ADMIN_OU_ENTITLEMENT_REQUEST),
    mergeMap((action: any) =>
      fetchOfficeEntitlementRequest(action.id).pipe(
        map((response: any) => officeEntitlementRequestSuccess(response)),
        catchError((error: any) => of(officeEntitlementRequestFailure(error)))
      )
    )
  );

const fetchCreateRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.ADMIN_CREATE_REQUEST),
    mergeMap((action: any) =>
      fetchCreateRequest(action.abilitationObj).pipe(
        map(() => createRequestSuccess()),
        catchError((error: any) => of(createRequestFailure(error)))
      )
    )
  );

const postChangePasswordEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.ADMIN_CHANGE_PASSWORD),
    mergeMap((action: any) =>
      postChangePassword(action.payload).pipe(
        map((response: any) => changePasswordActionSuccess(response)),
        catchError((error: any) => of(changePasswordActionFailure(error)))
      )
    )
  );

const fetchBAOEntitlementEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.ADMIN_BAO_ENTITLEMENT_REQUEST_USERS_MANAGEMENT),
    mergeMap((action: any) =>
      fetchBAOEntitlementRequest(action.id).pipe(
        map((response: any) => baoEntitlementRequestSuccess(response)),
        catchError((error: any) => of(baoEntitlementRequestFailure(error)))
      )
    )
  );

const fetchSODConflictsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.USERS_MANAGEMENT_SOD_CONFLICTS),
    mergeMap((action: any) =>
      fetchSODConflicts(action.payload).pipe(
        map((response: any) => sodConflictsActionSuccess(response)),
        catchError((error: any) => of(sodConflictsActionFailure(error)))
      )
    )
  );

const fetchPaginatedOfficeEntitlementsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.ADMIN_OFFICE_PAGINATED_ENTITLEMENT_REQUEST),
    mergeMap((action: any) =>
      getPaginatedEntitlementRequestService(action.payload).pipe(
        map((response: any) =>
          adminOfficePaginatedEntitlementRequestSuccess(response)
        ),
        catchError((error: any) =>
          of(adminOfficePaginatedEntitlementRequestFailure(error))
        )
      )
    )
  );

const fetchPaginatedOfficeBrsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.ADMIN_OFFICE_PAGINATED_BR_REQUEST),
    mergeMap((action: any) =>
      getPaginatedBusinessRoleRequestService(action.payload).pipe(
        map((response: any) => adminOfficePaginatedBrRequestSuccess(response)),
        catchError((error: any) =>
          of(adminOfficePaginatedBrRequestFailure(error))
        )
      )
    )
  );

const adminUpdateMobileEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.ADMIN_UPDATE_MOBILE_NUMBER),
    mergeMap((action: any) =>
      adminUpdateMobileService(action.payload).pipe(
        map((response: any) => updateMobileActionSuccess()),
        catchError((error: any) => of(updateMobileActionFailure(error)))
      )
    )
  );

const userManagementGetRolesEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.USERS_MGMT_GET_ROLES_ACTION),
    mergeMap((action: any) =>
      userManagementGetRolesService().pipe(
        map((response: any) => userManagementGetRolesActionSuccess(response)),
        catchError((error: any) =>
          of(userManagementGetRolesActionFailure(error))
        )
      )
    )
  );

const userManagementGetConfigsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.USERS_MGMT_GET_CONFIG_ACTION),
    mergeMap(() =>
      userManagementGetConfigsService().pipe(
        map((response: any) => userManagementGetConfigActionSuccess(response)),
        catchError((error: any) =>
          of(userManagementGetConfigActionFailure(error))
        )
      )
    )
  );

const userManagementGetButtonsByRoleEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.USERS_MGMT_GET_BUTTONS_BY_ROLE_ACTION),
    mergeMap((action: any) =>
      userManagementGetButtonsByRolesService(action.payload).pipe(
        map((response: any) =>
          userManagementGetButtonsByRoleActionSuccess(response)
        ),
        catchError((error: any) =>
          of(userManagementGetButtonsByRoleActionFailure(error))
        )
      )
    )
  );

const userManagementUpdateConfigButtonsEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.USERS_MGMT_UPDATE_CONFIG_BUTTONS_ACTION),
    mergeMap((action: any) =>
      userManagementUpdateConfigsService(action.payload).pipe(
        map((response: any) =>
          userManagementUpdateConfigButtonsActionSuccess(response)
        ),
        catchError((error: any) =>
          of(userManagementUpdateConfigButtonsActionFailure(error))
        )
      )
    )
  );

export default [
  fetchAdminUsersAccountRequestEpic,
  fetchResetPasswordEpic,
  fetchUserListEpic,
  fetchEntitlementRequestEpic,
  fetchBAOEntitlementEpic,
  fetchCreateRequestEpic,
  fetchOfficeEntitlementRequestEpic,
  fetchOfficeRequestsEpic,
  fetchUserRequestEpic,
  postChangePasswordEpic,
  fetchUnlockPassword,
  fetchSODConflictsEpic,
  fetchBlockAccountEpic,
  fetchGetPolicyAccountUsersMgmtEpic,
  fetchUserManagersRequestEpic,
  fetchUserOusRequestEpic,
  fetchPaginatedOfficeEntitlementsEpic,
  fetchPaginatedOfficeBrsEpic,
  adminUpdateMobileEpic,
  userManagementGetRolesEpic,
  userManagementGetButtonsByRoleEpic,
  userManagementUpdateConfigButtonsEpic,
  userManagementGetConfigsEpic,
];
